import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-j-message-article-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMessageArticlePanel = _resolveComponent("JMessageArticlePanel")!

  return (_ctx.messageArticleList)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageArticleList, (messageDetail, key) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "p-j-message-article-list__item",
            key: key
          }, [
            _createVNode(_component_JMessageArticlePanel, {
              "message-article-detail": messageDetail,
              exclude: _ctx.exclude
            }, null, 8, ["message-article-detail", "exclude"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}